import { render, staticRenderFns } from "./TodoNav.vue?vue&type=template&id=0e040a81&"
import script from "./TodoNav.vue?vue&type=script&lang=ts&"
export * from "./TodoNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports